import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import baseHelper from '../../../helpers/BaseHelper';
import appConst from '../../../config/const';
import Spinner from '../../../components/Spinner';
import storeActions from '../../../redux/futures/store/actions';
import Input from '../../../components/Input';
import CustomDatePicker from "../../../components/DatePicker/CustomDatePicker";

class EditAddon extends React.Component {
    static propTypes = {
        currentUser: PropTypes.object,
        onCancel: PropTypes.func,
        selectedResource: PropTypes.object
    }

    constructor(props) {
        super(props);
        const date = new Date();
        this.state = {
            id: false,
            limit_value: '',
            pkg_name: '',
            is_base_pkg: false,
            exp_date: date,
        };
        this.inputsRef = new Set();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.selectedResource) {
            console.log(nextProps.selectedResource);
            this.setState({
                id: nextProps.selectedResource._id,
                limit_value: String(nextProps.selectedResource.limit_value != null ? nextProps.selectedResource.limit_value : ''),
                pkg_name: nextProps.selectedResource.pkg_name || '',
                is_base_pkg: nextProps.selectedResource.is_base_pkg,
                exp_date: nextProps.selectedResource.exp_date ? new Date(nextProps.selectedResource.exp_date) : new Date(),
                resource_type: nextProps.selectedResource.resource_type,
                app_code: nextProps.selectedResource.app_code
            });
        }
    }

    handleLimitValueChange = (e) => {
        this.setState({ limit_value: e.target.value });
    }

    handleExpriredateChange = (date) => {
        this.setState({ exp_date: date });
    }

    handlePkgNameChange = (e) => {
        this.setState({ pkg_name: e.target.value });
    }

    handleSubmit = () => {
        const { limit_value, exp_date, resource_type, app_code, id, pkg_name, is_base_pkg } = this.state;
        if (!limit_value || !exp_date) {
            window.LadiUI.toastr('error', '', 'Vui lòng nhập đầy đủ thông tin');
            return;
        }

        const data = {
            ladi_uid: this.props.currentUser._id,
            app_code,
            resource_type,
            limit_value: parseInt(limit_value),
            pkg_name: pkg_name,
            exp_date: this.state.exp_date,
            id
        };
        if (is_base_pkg) {
            data.limit_value = 1;
        }
        // console.log(data);
        // return;
        this.props.updateResourceLimit(data);
    }

    render() {
        const { limit_value, exp_date, resource_type, app_code, pkg_name, is_base_pkg } = this.state;
        return (
            <div id="modal-edit-addon" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-edit-addon" style={{ zIndex: '22' }}>
                <div className="ladiui-modal-content">
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-edit-addon">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-edit-addon" />
                        </button>
                        <h3>Sửa giới hạn tài nguyên</h3>
                    </div>
                    <div className="ladiui-modal-body">
                        <div className="ladiui-form">
                            <div className="ladiui form-group">
                                <div className="ladiui-card">
                                    <div className="ladiui-card-body">
                                        <h3 style={{ marginBottom: '10px' }}>Thông tin hiện tại</h3>
                                        <div className="ladiui-row" style={{ height: '50px' }}>
                                            <div className="col-50">
                                                <strong>Ứng dụng: </strong>
                                                {app_code || '--'}
                                            </div>
                                            <div className="col-50">
                                                <strong>Loại tài nguyên: </strong>
                                                {resource_type || '--'}
                                            </div>
                                        </div>
                                        <div className="ladiui-row" style={{ height: '50px' }}>
                                            <div className="col-50">
                                                <strong>Giá trị giới hạn: </strong>
                                                {limit_value || '--'}
                                            </div>
                                            <div className="col-50">
                                                <strong>Ngày hết hạn: </strong>
                                                {baseHelper.formatStrToDate(exp_date) || '--'}
                                            </div>
                                        </div>
                                        {
                                            resource_type === 'store' &&
                                            <div className="ladiui-row" style={{ height: '50px' }}>
                                                <div className="col-50">
                                                    <strong>Tên gói: </strong>
                                                    {pkg_name || '--'}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="ladiui form-group">
                                <label className="ladiui-label">Giá trị giới hạn</label>
                                <Input
                                    ref={(ref) => this.inputsRef.add(ref)}
                                    name="limit_value"
                                    validationName="Giá trị giới hạn"
                                    placeholder="Giá trị giới hạn"
                                    value={limit_value}
                                    type='number'
                                    disabled={is_base_pkg || resource_type === 'store'}
                                    onChange={this.handleLimitValueChange}
                                    validations={{ isRequired: true, min: 0 }}
                                />
                            </div>
                            {
                                pkg_name && pkg_name !== '' &&
                                <div className="ladiui form-group">
                                    <label className="ladiui-label">Tên gói</label>
                                    <Input
                                        ref={(ref) => this.inputsRef.add(ref)}
                                        name="pkg_name"
                                        validationName="Tên gói"
                                        placeholder="Tên gói"
                                        value={pkg_name}
                                        onChange={this.handlePkgNameChange}
                                        validations={{ isRequired: true }}
                                    />
                                </div>
                            }
                            <div className="ladiui form-group">
                                <label className="ladiui-label">Ngày hết hạn</label>
                                <CustomDatePicker
                                    customClass="ladiui input date"
                                    selected={this.state.exp_date}
                                    onChange={this.handleExpriredateChange}
                                />
                            </div>

                            <div className="ladiui form-group text-right">
                                <button
                                    className="ladiui button primary"
                                    onClick={this.handleSubmit}
                                >
                                    Cập nhật
                                </button>
                            </div>
                        </div>
                        {this.props.loading && <Spinner />}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.store.loading
});

const mapDispatchToProps = (dispatch) => ({
    updateResourceLimit: (data) => dispatch(storeActions.updateResourceLimit(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAddon); 